import { Record as ImmutableRecord } from 'immutable';
const LoggingContext = ImmutableRecord({
  error: null,
  fingerprint: undefined,
  extra: {},
  tags: {}
}, 'LoggingContext');
export { LoggingContext };